import React from 'react';
import './radio.scss';
export function Radio({ label, name, onChange, checked, disabled }) {
    return React.createElement(React.Fragment, null,
        React.createElement("label", { className: `smp-radio` },
            !disabled && (React.createElement("input", { onChange: onChange, type: "radio", name: name, checked: checked })),
            React.createElement("div", { className: "smp-radio-input" }),
            React.createElement("div", { className: "smp-radio-label" }, label)));
}
